<template>
  <div class="osk-wrapper vertical-paddings">
    <h2 class="section-title text-center mb-4">
      {{ $t('common.offer') }}
    </h2>

    <div class="section-subtitle text-center subtitle">
      {{ $t('components.info.ofertaPage.subtitle') }}
    </div>

    <div class="tree_block">
      <ul style="justify-content: normal;">
        <li
          v-for="doc in documents"
          :key="doc.title"
        >
          <a
            target="_blank"
            :href="doc.link"
          >
            {{ doc.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

useHead({
  title: `${t('common.offer')} – ${t('common.OskellyOnlineStore')}`,
  meta: [
    {
      name: 'description',
      content: `${t('common.offer')} – ${t('common.OskellyOnlineStore')}`,
    },
  ],
});

const documents = [
  {
    title: t('components.info.ofertaPage.document1.title'),
    link: '/info/pdf/buyer-license.pdf',
  },
  {
    title: t('components.info.ofertaPage.document2.title'),
    link: '/info/pdf/seller-agency-agreement.pdf',
  },
  {
    title: t('components.info.ofertaPage.document3.title'),
    link: '/info/pdf/sale-contract.pdf',
  },
  {
    title: t('components.info.ofertaPage.document4.title'),
    link: '/info/pdf/copyright-holders.pdf',
  },
  {
    title: t('components.info.ofertaPage.document5.title'),
    link: '/info/pdf/oplata-yandex-split.pdf',
  },
  {
    title: 'Программа лояльности',
    link: '/info/pdf/community-rules.pdf',
  },
];
</script>

<style scoped lang="scss">
.vertical-paddings {
  padding-top: 70px;
  padding-bottom: 100px;
}

.tree_block {
  margin-top: 40px;
}

.tree_block ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 -13px;
}

.tree_block ul li {
  width: calc(33.333333% - 26px);
  margin: 13px;
}

.tree_block ul li a {
  display: block;
  padding: 22px 5px;
  text-align: center;
  letter-spacing: -.4px;
  border: 1px solid rgba(189, 189, 189, 0.6);
  border-radius: 2px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 18px;
  transition: all 0.3s ease;
}

.tree_block ul li a:hover {
  background: rgba(189, 189, 189, 0.6);
}

@media only screen and (max-width: 1250px) {
  .tree_block ul {
    margin: 0 -10px;
  }

  .tree_block ul li {
    width: calc(33.3333333% - 20px);
    margin: 13px 10px;
  }

  .tree_block ul li a {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1024px) {
  .vertical-paddings {
    padding-top: 57px;
    padding-bottom: 81px;
  }

  .tree_block {
    margin-top: 51px;
  }

  .tree_block ul {
    display: block;
    margin: 0 auto;
    max-width: 430px;
  }

  .tree_block ul li {
    width: 100%;
    margin: 0 0 40px;
  }

  .tree_block ul li:last-child {
    margin-bottom: 0;
  }

  .tree_block ul li a {
    font-size: 18px;
  }
}

@media only screen and (max-width: 767px) {
  .tree_block {
    margin-top: 24px;
  }

  .tree_block ul li {
    margin: 0 0 14px;
  }

  .tree_block ul li a {
    padding: 15px 5px;
    font-size: 12px;
  }
}
</style>
